import { render, staticRenderFns } from "./eliminarAsistente.vue?vue&type=template&id=e2d0771c&"
import script from "./eliminarAsistente.vue?vue&type=script&lang=js&"
export * from "./eliminarAsistente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports